<template>
  <div>
    <LanguageSelector />
    <div class="content-header row"></div>
    <div class="content-body">
      <section id="basic-datatable">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-content">
                <div class="card-header">
                  <h5 class="card-title">{{$t('Manage Issues')}}</h5>
                  <div class="heading-elements">
                    <ul class="list-inline mb-0">
                      <li style="margin-right: 1em">
                        <div class="has-icon-left">
                          <select
                            class="form-control"
                            v-model="statusFilter"
                            @change="filterByStatus(statusFilter)"
                          >
                            <option selected>{{$t('All Status...')}}</option>
                            <option value="open">{{$t('Open')}}</option>
                            <option value="resolved">{{$t('Resolved')}}</option>
                          </select>
                          <div class="form-control-position">
                            <em class="bx bx-filter font-medium-1"></em>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="has-icon-left">
                          <input
                            type="text"
                            class="form-control"
                            @keyup="searchInTable()"
                            v-model="searchInputText"
                            :placeholder="$t('Search...')"
                          />
                          <div class="form-control-position">
                            <em class="bx bx-search font-medium-1"></em>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="card-body card-dashboard">
                  <div class="text-center">
                    <div
                      class="spinner-border text-primary"
                      role="status"
                      v-if="loadingData"
                      style="opacity: 0.6"
                    >
                      <span class="sr-only">{{$t('Loading...')}}</span>
                    </div>
                  </div>
                  <div
                    class="text-center mt-1"
                    v-if="!issues.length && !loadingData"
                  >
                    <p>{{$t('No Issues Found...')}}</p>
                  </div>
                  <div class="table-responsive" v-if="issues.length">
                    <table class="table zero-configuration" :aria-label="$t('issues_arial_label_issue_list')">
                      <thead>
                        <tr>
                          <th>{{$t('Title')}}</th>
                          <th>{{$t('Contract')}}</th>
                          <th>{{$t('Created By')}}</th>
                          <th>{{$t('Urgency')}}</th>
                          <th>{{$t('Status')}}</th>
                          <th>{{$t('Created At')}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(issue, index) in issues" :key="index">
                          <td class="issueName">
                            {{ issue.title }}
                            <br />
                            <router-link
                              :to="{name: 'IssuesSinglePage', params: {uuid: issue.id} }"
                              href="#"
                              style="margin-top: 5px;"
                            >
                              {{$t('View Details')}}
                            </router-link>
                          </td>
                          <td>
                            {{ issue.contractId }}
                          </td>
                          <td>
                            {{
                              issue.createdByUser.name
                                ? issue.createdByUser.name
                                : "-"
                            }}
                          </td>
                          <td>
                            <span v-if="issue.urgent === true">
                              <em
                                class="bx bxs-circle danger font-small-1 mr-50"
                              ></em>
                              {{$t('High')}}
                            </span>
                            <span v-if="issue.urgent === false">
                              <em
                                class="bx bxs-circle warning font-small-1 mr-50"
                              ></em>
                              {{$t('Low')}}
                            </span>
                          </td>
                          <td>
                            <span v-if="issue.status === 'open'">
                              <em
                                class="bx bxs-circle danger font-small-1 mr-50"
                              ></em>
                              {{$t('Open')}}
                            </span>
                            <span v-if="issue.status === 'resolved'">
                              <em
                                class="bx bxs-circle success font-small-1 mr-50"
                              ></em>
                              {{$t('Resolved')}}
                            </span>
                          </td>
                          <td>{{ issue.createdAt.split("T")[0] }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { getCountryName } from "@/app-assets/js/get-countries.js";
import "@/app-assets/js/scripts/extensions/ext-component-block-ui.js";
import Alert from "@/components/Alerts";
export default {
  data() {
    return {
      usersCountries: [],
      issues: [],
      loadingData: true,
      statusFilter: "All Status...",
      searchInputText: "",
    };
  },
  components: {
    Alert,
  },

  computed: {
    isSuperadmin() {
      return this.$store.state.currentUser.user.type === "superadmin";
    },
  },

  methods: {
    getIssues() {
      this.loadingData = true;
      this.$apiCall
        .get("/v1/issues/")
        .then((response) => {
          this.issues = response.data.data;
          this.loadingData = false;
          response.data.data.map((el) => {
            if (!this.usersCountries.includes(el.country)) {
              this.usersCountries.push(el.country);
            }
          });
          this.initDataTable();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    searchInTable() {
      var value = this.searchInputText.toLowerCase();
      $(".zero-configuration > tbody tr").filter(function () {
        $(this).toggle(
          $(this).find(".issueName").text().toLowerCase().indexOf(value) > -1
        );
      });
    },

    filterByStatus(status) {
      let self = this;
      if (status != "All Status...") {
        self.loadingData = true;
        self.issues = [];
        self.$apiCall
          .get(`/v1/issues?status=${status.toLowerCase()}`)
          .then((response) => {
            self.loadingData = false;
            self.issues = response.data.data;
            self.initDataTable();
          });
      } else {
        self.issues = [];
        self.usersCountries = [];
        self.getIssues();
      }
    },

    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase());
      }
    },

    initDataTable() {
      setTimeout(function () {
        $(".zero-configuration").DataTable({
          //   scrollX: true,
          bLengthChange: false,
          bFilter: false,
          order: [],
        });
      }, 100);
    },
  },

  mounted() {
    this.getIssues();
  },
};
</script>

<style scoped>
table {
  white-space: nowrap;
}
</style>